<template>
    <div class="modal-content land-flat-modal-content">
        <button class="btn-close-flat-card--modal" @click="closeFlatModal()"><svg-icon icon-class="close" className="icon-close"/></button>
        <div class="col-left" :class="{active: resizeCardImg}">
            <div class="btn-resize" :class="{active: resizeCardImg}" @click="resizeModalCardImg">
                <svg-icon icon-class="inresize" className="icon-inresize"/>
                <svg-icon icon-class="unresize" className="icon-unresize"/>
            </div>
            <div class="flat-card-big-img">
                <img :src="'data:image/' + modalData.flats_card_img.pictureformat + '+xml;base64,' + modalData.flats_card_img.binary" alt="">
            </div>
            <div class="flat-card-info-images">
                <div class="col">
                    <img :src="'data:image/' + modalData.flats_card_modal.rose.pictureformat + '+xml;base64,' + modalData.flats_card_modal.rose.binary" alt="">
                </div>
                <div class="col">
                    <img :src="'data:image/' + modalData.flats_card_modal.plan.pictureformat + '+xml;base64,' + modalData.flats_card_modal.plan.binary" alt="">
                </div>
                <!-- <div class="col">
                    <img :src="modalData.flats_card_modal.house_plan" alt="">
                </div> -->
            </div>
        </div>
        <div class="col-right">
            <div class="flat-card-top-info">
                <div class="info-item">
                    <h3><span>{{modalData.flats_card_room}}</span>комнатная квартира</h3>
                </div>
                <div class="info-item">
                    <div class="item">
                        <div class="in">
                            <p>{{flats.land_flats_cards_info.size}} -</p>
                            <strong>{{modalData.flats_card_size}}<span>м²</span></strong>
                        </div>
                    </div>
                    <div class="item">
                        <div class="in">
                            <p>Цена -</p>
                            <strong><span class="start">от </span>{{modalData.flats_card_price_min.slice(0,3)}} 000<span class="wollet">₸</span><span> за м²</span></strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flat-card-btns-container">
                <div class="flat-btn-print">
                    <a href="#" class="btn-print" @click.prevent="blopPdf(modalData.flats_card_modal.pdf.binary, modalData.flats_card_room, modalData.flats_card_size, )">
                        <svg-icon icon-class="print" className="icon-print"/>
                        <p v-if="!this.config[0].mobile">{{flats.land_flats_cards_info.flat_btn_print_name}}</p>
                        <p v-else>{{flats.land_flats_cards_info.flat_btn_print_name_mobile}}</p>
                    </a>
                </div>
                <div class="flat-btn-mail">
                    <a href="#" class="btn-mail" @click.prevent="InputMailInit"  v-if="!formActive"> 
                        <svg-icon icon-class="mail" className="icon-mail"/>
                        <p>{{flats.land_flats_cards_info.flat_btn_mail_name}}</p>
                    </a>
                    <transition name="fade">
                        <formMail v-if="formActive"
                                :options="[{pdf: modalData.flats_card_modal.pdf}]"
                        ></formMail>
                    </transition>
                </div>
                <div class="flat-social-share-btns">
                    <div class="flats-social-share-title">
                        <h4>{{flats.land_flats_cards_info.flat_btn_social_title}}</h4>
                    </div>
                    <!-- <button class="button btn-share-flat-to-social btn-share-flat-to-social-desctop" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.flats_card_room.number + ' ' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.flats_card_size + ' м²' + ' в SOHO'" :data-url="modalData.flats_card_modal.pdf" data-web><svg-icon icon-class="whatsapp-flat" className="flat-share-icon icon-whatsapp"/></button>
                    <button class="button btn-share-flat-to-social btn-share-flat-to-social-mobile" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.flats_card_room.number + ' ' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.flats_card_size + ' м²' + ' в SOHO'" :data-url="modalData.flats_card_modal.pdf"><svg-icon icon-class="whatsapp-flat" className="flat-share-icon icon-whatsapp"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="telegram" :data-title="'Ваша' + ' ' + modalData.flats_card_room + ' ' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.flats_card_size + ' м²' + ' в SOHO'" :data-url="modalData.flats_card_modal.pdf"><svg-icon icon-class="telegram" className="flat-share-icon icon-telegram"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="facebook" data-hashtag="МояКвартира_в_SOHO" :data-url="modalData.flats_card_modal.pdf"><svg-icon icon-class="facebook-flat" className="flat-share-icon icon-facebook"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="vk" :data-title="'Ваша' + ' ' + modalData.flats_card_room.number + ' ' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.flats_card_size + ' м²' + ' в SOHO'" :data-url="modalData.flats_card_modal.pdf"><svg-icon icon-class="vk-flat" className="flat-share-icon icon-vk"/></button> -->
                </div>
            </div>
            <!-- <div class="flat-card-form">
                <div class="flat-card-form-titles">
                    <h3>{{form.flats_form_title}}</h3>
                    <p>{{form.flats_form_desc}}</p>
                </div>
                <formFields class="form-flats-card-setup"></formFields>
            </div> -->
        </div>
    </div>
</template>

<script>
	// import formFields from '@/components/forms/form-flat.vue';
	// import formMail from '@/components/forms/form-mail.vue';	
    import {mapGetters} from 'vuex'
	export default {
        name: 'flat-modal',
        props: ['config'],
		components: {
			// formFields,
			// formMail,
		},
		data () {
			return {
                formActive: this.config[0].active,
                resizeCardImg: false,
			}
        },
        computed: mapGetters({
            flats: 'loadSalesCardPage',
			modalData: 'loadSalesLandModalDataArr',
        }),
		// computed: {
		// 	flats () {
		// 		return this.$store.state.flats
		// 	},
		// 	form () {
		// 		return this.$store.state.forms
		// 	},
		// 	modalData() {
        //         return this.$store.state.modalData
		// 	},
		// },
		methods: {
			closeFlatModal() {
				this.$modal.hide('sales_land_flat-card-modal');
            },
            InputMailInit() {
				this.formActive = true;
            },
            resizeModalCardImg() {
				this.resizeCardImg = !this.resizeCardImg;
            },
            openPdfFile(filePdf, room, size) {
                console.log('work', filePdf);
                var objbuilder = '';
                objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
                objbuilder += (filePdf);
                objbuilder += ('" type="application/pdf" class="internal">');
                objbuilder += ('<embed src="data:application/pdf;base64,');
                objbuilder += (filePdf);
                objbuilder += ('" type="application/pdf"  />');
                objbuilder += ('</object>');

                var win = window.open("#","_blank");
                var title = room + '-x' + " комнатная квартира " + size;
                win.document.write('<html><title>'+ title +'</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
                win.document.write(objbuilder);
                win.document.write('</body></html>');
                layer = jQuery(win.document);
            },
            blopPdf(filePdf) {
                var type = 'application/pdf';
                let blob = null;
                const blobURL = URL.createObjectURL( this.pdfBlobConversion(filePdf, 'application/pdf'));
                const theWindow = window.open(blobURL);
                const theDoc = theWindow.document;
                const theScript = document.createElement('script');
                function injectThis() {
                    window.print();
                }
                theScript.innerHTML = 'window.onload = ${injectThis.toString()};';
                theDoc.body.appendChild(theScript);
            },
            pdfBlobConversion(b64Data, contentType) {
                contentType = contentType || '';
                var sliceSize = 512;
                b64Data = b64Data.replace(/^[^,]+,/, '');
                b64Data = b64Data.replace(/\s/g, '');
                var byteCharacters = window.atob(b64Data);
                var byteArrays = [];

                for ( var offset = 0; offset < byteCharacters.length; offset = offset + sliceSize ) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, { type: contentType });
                return blob;
            }
		},
		mounted() {
			// this.$store.watch(
			// 	(state) => state.flatCards,
			// 	(newValue) => {
			// 		if (newValue.length >= 4) {
			// 		}
			// 	}
			// )
		}
	}
</script>

<style lang="scss" scoped>
    @import '@/styles/components/sales/sales-land-partials/land-flats-modal.scss';
    @import '@/styles/respond/sales/sales-land-partials/flats-partials/flat-modal-respond.scss';
	// @import '@/styles/components/flats/modal.scss';
    // @import '@/styles/components/forms/form-flat.scss';
    // @import '@/styles/components/flats/flats-respond/modal-respond.scss';
    // @import '@/styles/components/forms/forms-respond/form-flat-respond.scss';
	// @import '@/styles/components/animation/animation-flat.scss';
</style>